import { render, staticRenderFns } from "./SectionTitleWithDescription.vue?vue&type=template&id=39e72f26&scoped=true&"
import script from "./SectionTitleWithDescription.vue?vue&type=script&lang=js&"
export * from "./SectionTitleWithDescription.vue?vue&type=script&lang=js&"
import style0 from "./SectionTitleWithDescription.vue?vue&type=style&index=0&id=39e72f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e72f26",
  null
  
)

export default component.exports